<template>
  <div class="content app-top-bar">
    <div class="left">
      <div class="logo" @click="jump('/')">
        <img :src="Logo" alt="" />
      </div>
    </div>
    <div class="center">
      <div
        v-for="item in navMenus"
        :key="item.menuCode"
        class="center-item"
        @click="jump(item.routePath)"
      >
        {{ item.menuName }}
      </div>
    </div>
    <div class="right">
      <div class="" v-if="hasLogin">
        <el-popover placement="bottom" trigger="hover">
          <template #reference>
            <div
              class="header-avatar"
              :style="headerAvatarStyle"
              title="进入个人中心"
              @click.stop="jump('/myCenter')"
            >
              <img :src="headerAvatarSrc" alt="头像" @error="onAvatarError" />
            </div>
          </template>
          <div class="top_left">
            <div
              class="header-avatar header-avatar--popover"
              :style="headerPopoverAvatarStyle"
            >
              <img :src="headerAvatarSrc" alt="头像" @error="onAvatarError" />
            </div>
            <div class="info">
              <div class="username">{{ userInfo.username }}</div>
              <div class="id">{{ userInfo.phone }}</div>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="login" v-if="!hasLogin" @click="jump('/login')">
        <div class="header-avatar" :style="headerAvatarStyle">
          <img :src="defaultAvatar" alt="头像" />
        </div>
      </div>

      <img :src="car" alt="" class="item" @click="jump('/shoppingCar')" />

      <el-dropdown @command="settingMenuItemClick">
        <img :src="setting" class="item" />
        <template #dropdown>
          <el-dropdown-menu>
            <template v-if="hasLogin">
              <el-dropdown-item command="myOrder">我的订单</el-dropdown-item>
              <el-dropdown-item command="wallet">我的钱包</el-dropdown-item>
              <el-dropdown-item command="myCenter">个人中心</el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                退出登录
              </el-dropdown-item>
            </template>
            <el-dropdown-item v-else command="login">登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useNavMenuStore } from "@/stores/navMenu";
import defaultAvatar from "@/assets/images/avatar.jpg";
import car from "@/assets/images/svg/cart.svg";
import setting from "@/assets/images/svg/setting.svg";
import Logo from "@/assets/images/svg/UniverseX.svg";

// 页头内头像尺寸，直接在此处改即可
const HEADER_AVATAR_SIZE = 32;
const HEADER_POPOVER_AVATAR_SIZE = 40;

const router = useRouter();
const userStore = useUserStore();
const navMenuStore = useNavMenuStore();

const navMenus = computed(() => navMenuStore.menus);

const headerAvatarSrc = computed(
  () => userStore.userInfo?.icon || defaultAvatar
);
const headerAvatarStyle = computed(() => ({
  width: `${HEADER_AVATAR_SIZE}px`,
  height: `${HEADER_AVATAR_SIZE}px`,
}));
const headerPopoverAvatarStyle = computed(() => ({
  width: `${HEADER_POPOVER_AVATAR_SIZE}px`,
  height: `${HEADER_POPOVER_AVATAR_SIZE}px`,
}));

const onAvatarError = (e) => {
  if (e.target && e.target.src !== defaultAvatar) {
    e.target.src = defaultAvatar;
  }
};

const settingVisible = ref(false);
const hasLogin = computed(() => userStore.userInfo?.id);
const userInfo = computed(() => userStore.userInfo);

const jump = (url) => {
  router.push(url);
};

const settingMenuItemClick = (type = "") => {
  switch (type) {
    case "login":
      jump("/login");
      break;
    case "myOrder":
      router.push("/myOrder");
      break;
    case "myCenter":
      router.push("/myCenter");
      break;
    case "wallet":
      router.push("/wallet");
      break;
    case "logout":
      userStore.logout();
      router.push("/login");
      break;
    default:
      break;
  }
  settingVisible.value = false;
};

onMounted(() => {
  if (!navMenuStore.loaded) {
    navMenuStore.fetchMenus();
  }
});
</script>

<style lang="scss" scoped>
@import "@/style/rx";

.content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 86px;
  color: var(--ux-text-secondary);
  font-family: $font_YaHei;
  font-weight: 500;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: var(--ux-glass-bg-header, rgba(255, 255, 255, 0.06));
  backdrop-filter: var(--ios-glass-blur-heavy, saturate(200%) blur(32px));
  -webkit-backdrop-filter: var(
    --ios-glass-blur-heavy,
    saturate(200%) blur(32px)
  );
  border-bottom: 0.5px solid var(--ux-glass-border, rgba(255, 255, 255, 0.14));
  border-radius: 0 0 22px 22px;
  box-shadow: var(--ux-glass-shadow, 0 8px 32px rgba(0, 0, 0, 0.35));
  z-index: 1000;
  padding: 0 240px;
}

.left {
  margin-right: 122px;
  text-align: center;
  cursor: pointer;
  .logo {
    width: 138px;
    height: 29px;
    img {
      width: 100%;
    }
  }
}

.center {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.login {
  cursor: pointer;
  font-size: 24px;
}

.right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.center-item {
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  color: var(--ux-text-secondary);
  line-height: 26px;
  text-align: center;
  padding: 8px 16px;
  border-radius: 980px;
  transition: color 0.2s ease, background 0.2s ease,
    transform 0.18s cubic-bezier(0.25, 0.1, 0.25, 1);
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: var(--ux-accent);
    background: rgba(0, 212, 255, 0.1);
  }
  &:active {
    transform: scale(0.96);
  }
}

.item {
  height: 24px;
  padding: 0 10px;
  cursor: pointer;
}

.header-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  display: block;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.header-avatar--popover {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
}

.top_left {
  display: flex;
  align-items: center;

  .header-avatar--popover {
    margin-right: 14px;
  }

  .info {
    .username {
      font-weight: 400;
      font-size: 12px;
      color: var(--ux-text-primary);
      line-height: 23px;
      letter-spacing: 3px;
    }
    .id {
      font-weight: 400;
      font-size: 12px;
      color: var(--ux-text-muted);
      line-height: 19px;
    }
  }
}
</style>
